import { SfSelectOption } from 'ngx-smart-form';
import { Product, ProductType } from '../app/requests/models/product';
import { PraticaAggregator } from '../app/settings/header-requests/pratica-aggregator';
import { Soggetto } from '../app/anagraphics/models/cms-document-fields';
import { Role } from './account';

export class Pratica {
  associazioni: IPratica['associazioni'];
  channel: string;
  erogante: string;
  garante: string;
  denomination: string;
  state: StatoPratica;
  id: string;
  isCloned: boolean;
  praticaCode: string;
  piva: string;
  target: Target;
  user: string;
  userCreator: string;
  process?: { richiesta: string; istruttoria?: string };
  products: ProductType[];
  progress?: Partial<PraticaProgress>;
  dataPrenotazioneStipula?: null | number;
  tipoSoggetto: Soggetto;
  type: PraticaType;
  dataCambioStatoPratica: number;
  linkCassettoFiscale: string | null;
  zipStatus: ZipStatus;
  productDetail?: Product;
  emailCwbi: string;
  statusCwbi: CwbiStatus;
  constructor(data: IPratica, prodotti?: Product[]) {
    this.associazioni = data.associazioni;
    this.id = data.id;
    this.isCloned = data.isCloned;
    this.praticaCode = data.codicePratica;
    this.channel = data.canale;
    this.erogante = data.erogante;
    this.garante = data.garante;
    this.denomination = data.denominazione;
    this.state = data.stato;
    this.piva = data.piva;
    this.target = data.target;
    this.user = data.user;
    this.userCreator = data.userCreator;
    this.process = data.process;
    this.products = data.prodotti;
    this.progress = data.progress;
    this.dataPrenotazioneStipula = data.dataPrenotazioneStipula;
    this.tipoSoggetto = data.tipoSoggetto;
    this.type = data.tipo;
    this.dataCambioStatoPratica = data.dataCambioStatoPratica;
    this.linkCassettoFiscale = data.linkCassettoFiscale;
    this.zipStatus = data.zipStatus;
    this.productDetail = prodotti?.[0];
    this.emailCwbi = data.emailCwbi;
    this.statusCwbi = data.statusCwbi || 'NOT_STARTED';
  }
}

export interface IPratica {
  associazioni: {
    praticaAml?: string;
    praticaFin?: string;
  };
  canale: string;
  codicePratica: string;
  id: string;
  isCloned: boolean;
  piva: string;
  stato: StatoPratica;
  target: Target;
  user: string;
  userCreator: string;
  denominazione: string;
  erogante: string;
  garante: string;
  process: { richiesta: string; istruttoria?: string };
  prodotti: ProductType[];
  progress?: Partial<PraticaProgress>;
  dataPrenotazioneStipula?: null | number;
  timestampIns: number;
  timestampMod: number;
  tipoSoggetto: Soggetto;
  tipo: PraticaType;
  dataCambioStatoPratica: number;
  linkCassettoFiscale: string | null;
  zipStatus: ZipStatus;
  emailCwbi: string;
  statusCwbi: CwbiStatus;
}

export interface PraticaSearchDTO {
  assegnataA: string;
  canale: string;
  codicePratica: string;
  denominazione: string;
  partitaIvaCF: string;
  target: string;
  statiPratica: string[];
  erogante: string;
  garante: string;
  inbox: boolean;
  dateStipula: string; //iso string
  prodotti: ProductType;
  praticaTypes: PraticaType;
  importo: number;
  tipoSoggetto: Soggetto;
}

export enum Target {
  IMPRESE = 'imprese',
  PROFESSIONISTI = 'professionisti',
}

export enum StatoPratica {
  APERTA = 'APERTA',
  NON_CONSENTITA = 'NON CONSENTITA',
  CONFERMATA = 'CONFERMATA',
  IN_FIRMA = 'IN FIRMA',
  DECLINATA = 'DECLINATA',
  RIFIUTO_CLIENTE = 'RIFIUTO CLIENTE',
  FIRMATA = 'FIRMATA',
  IN_RICHIESTA_DOCUMENTALE = 'RICHIESTA DOCUMENTALE',
  DOCUMENTAZIONE_INTEGRATA = 'DOCUMENTAZIONE INTEGRATA',
  IN_ASSEGNAZIONE = 'IN ASSEGNAZIONE',

  //CRESCIFARMA
  IN_PREVALUTAZIONE = 'IN PREVALUTAZIONE',

  NON_PROCESSABILE = 'NON PROCESSABILE',

  IN_VALUTAZIONE_GARANZIA = 'IN VALUTAZIONE GARANZIA',
  IN_VALUTAZIONE_EROGAZIONE = 'IN VALUTAZIONE EROGAZIONE',

  //CRESCIFARMA
  //IN_VALUTAZIONE_DELIBERA = 'IN VALUTAZIONE DELIBERA',
  DELIBERATA = 'DELIBERATA',

  RICHIESTA_INTEGRAZIONI = 'RICHIESTA INTEGRAZIONI',
  RICHIESTA_INTEGRAZIONI_CANALE = 'RICHIESTA INTEGRAZIONI CANALE',
  PROPOSTA_MODIFICA = 'PROPOSTA MODIFICA',
  PROPOSTA_MODIFICA_CANALE = 'PROPOSTA MODIFICA CANALE',
  PROPOSTA_DECLINO_CANALE = 'PROPOSTA DECLINO CANALE',

  AGGIUNTA_GARANTE = 'IN AGGIUNTA GARANTE',
  IN_FIRMA_GARANTE = 'IN FIRMA GARANTE',
  ATTESA_MCC = 'ATTESA MCC',
  DELIBERA_MCC = 'DELIBERA MCC',

  //CRESCIFARMA
  IN_PRENOTAZIONE_STIPULA = 'IN PRENOTAZIONE STIPULA',

  PRENOTATA_STIPULA = 'PRENOTATA STIPULA',
  IN_STIPULA = 'IN STIPULA',
  STIPULATO = 'STIPULATO',
  RISPOSTA_CANALE = 'RISPOSTA CANALE',
  EROGATO = 'EROGATO',

  //AML
  ANNULLATA = 'ANNULLATA',
  COMPLETATA = 'COMPLETATA',
  CONVALIDATO = 'CONVALIDATO',
  IN_VALUTAZIONE_RISK = 'IN VALUTAZIONE RISK',
  IN_VALUTAZIONE_AD = 'IN VALUTAZIONE AD',
  AUTORIZZATO = 'AUTORIZZATO',
  RIFIUTATO = 'RIFIUTATO',
}

export const getStatoPraticaOptions: (
  isCalendarView: boolean,
  praticaType: PraticaType,
  role: Role | undefined
) => SfSelectOption[] = (isCalendarView, praticaType, role) => {
  let options: SfSelectOption<StatoPratica>[] = [];
  const amlStates: StatoPratica[] = [
    StatoPratica.ANNULLATA,
    StatoPratica.COMPLETATA,
    StatoPratica.IN_VALUTAZIONE_RISK,
    StatoPratica.IN_VALUTAZIONE_AD,
    StatoPratica.CONVALIDATO,
    StatoPratica.RIFIUTATO,
    StatoPratica.AUTORIZZATO,
  ];
  const sharedStates: StatoPratica[] = [
    StatoPratica.APERTA,
    StatoPratica.IN_FIRMA,
    StatoPratica.FIRMATA,
  ];
  for (let key in StatoPratica) {
    options.push({ value: StatoPratica[key], view: StatoPratica[key] });
  }
  let states = !isCalendarView
    ? options.filter((option) => {
        return praticaType === 'FIN'
          ? !amlStates.includes(option.value)
          : amlStates.includes(option.value) ||
              sharedStates.includes(option.value);
      })
    : [
        { value: StatoPratica.IN_STIPULA, view: StatoPratica.IN_STIPULA },
        {
          value: StatoPratica.PRENOTATA_STIPULA,
          view: StatoPratica.PRENOTATA_STIPULA,
        },
        { value: StatoPratica.STIPULATO, view: StatoPratica.STIPULATO },
        { value: StatoPratica.EROGATO, view: StatoPratica.EROGATO },
      ];

  if (role === 'Addetto' || role === 'Responsabile') {
    states = states.filter(
      (state) => state.value !== StatoPratica.PROPOSTA_MODIFICA
    );
  }
  return states;
};

export interface PraticaProgress {
  applicant: number;
  requests: number;
  anagraphics: number;
  score: number;
  presentationSheet: number;
  documents: number;
  total?: number;
}

export type PraticaType = 'FIN' | 'AML';

export type ZipStatus = 'CREATING' | 'READY' | 'ERROR';

export type CwbiStatus =
  | 'CREATED'
  | 'PENDING'
  | 'RUNNING'
  | 'DOWNLOAD_PARTIAL'
  | 'DOWNLOAD_COMPLETED'
  | 'AUTHORIZED'
  | 'REJECTED'
  | 'ERROR'
  | 'EXPIRED'
  | 'DELETED'
  | 'NOT_STARTED'; //FE only, applies when the status is not present in the response
